import { Injectable } from '@angular/core';

import { BhApi, Empty } from '@mark/web-contracts';
import { from } from 'rxjs';
import { grpcOperator } from '@stress/app/core/api/grpc/pipe-operators/grpc';

import { GrpcCommonService } from './common.service';

@Injectable()
export class LocalizationGrpcContractService extends GrpcCommonService<BhApi.LocalizationBhGrpcContractClient> {
  constructor(protected _GrpcContract: BhApi.LocalizationBhGrpcContractClient) {
    super();
  }

  getLanguages() {
    return from(this._GrpcContract.GetLanguages(new Empty(), this.getMetadata())).pipe(grpcOperator());
  }

  getLocalization() {
    return from(this._GrpcContract.GetTranslates(new Empty(), this.getMetadata())).pipe(grpcOperator());
  }
}
